import { api } from "../../app/api";
import { EventPayload } from "../../common/types/Event";
import { Options } from "../../common/types/requestOptions";
import {
  AddTalentWorkHistoryEntry,
  RemoveTalentWorkHistoryEntry,
  UpdateTalentWorkHistoryEntry,
} from "./types/commands";
import {
  TalentWorkHistoryEntryAdded,
  TalentWorkHistoryEntryRemoved,
  TalentWorkHistoryEntryUpdated,
} from "./types/events";
import {
  WorkHistory,
  WorkHistoryById,
  WorkHistorySummaryById,
  WorkHistorySummaryResponse,
} from "./types/queries";

export const listWorkHistoriesByTalentId = (
  { id, lang }: WorkHistoryById,
  { requestId }: Options = {},
) => {
  return api.get<WorkHistory[]>(
    `/projections/qry/workHistoryById?id=${id}&language=${lang}`,
    {
      requestId,
      auth: true,
    },
  );
};

export const listWorkHistorySummaryByTalentId = (
  { id, lang }: WorkHistorySummaryById,
  { requestId }: Options = {},
) => {
  const languageParam = lang ? `&language=${lang}` : "";
  return api.get<WorkHistorySummaryResponse>(
    `/projections/qry/workHistorySummary?id=${id}${languageParam}`,
    {
      requestId,
      auth: true,
    },
  );
};

export const postAddTalentWorkHistoryEntry = async (
  command: AddTalentWorkHistoryEntry,
  { requestId }: Options,
): Promise<EventPayload<TalentWorkHistoryEntryAdded>> => {
  const params = {
    requestId,
    auth: true,
    body: command,
  };

  return await api
    .post<
      EventPayload<TalentWorkHistoryEntryAdded>[]
    >("/matching/cmd/addTalentWorkHistoryEntry", params)
    .then((res) => res.data[0]);
};

export const postUpdateTalentWorkHistoryEntry = async (
  command: UpdateTalentWorkHistoryEntry,
  { requestId }: Options,
): Promise<EventPayload<TalentWorkHistoryEntryUpdated>> => {
  const params = {
    requestId,
    auth: true,
    body: command,
  };

  return await api
    .post<
      EventPayload<TalentWorkHistoryEntryUpdated>[]
    >("/matching/cmd/updateTalentWorkHistoryEntry", params)
    .then((res) => res.data[0]);
};

export const postRemoveTalentWorkHistoryEntry = async (
  command: RemoveTalentWorkHistoryEntry,
  { requestId }: Options,
): Promise<EventPayload<TalentWorkHistoryEntryRemoved>> => {
  const params = {
    requestId,
    auth: true,
    body: command,
  };

  return await api
    .post<
      EventPayload<TalentWorkHistoryEntryRemoved>[]
    >("/matching/cmd/removeTalentWorkHistoryEntry", params)
    .then((res) => res.data[0]);
};
